import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  TablePagination,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import "./PipesDetails.css";
import { images } from "../../config/images";
import { Link } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import {
  exportScannedPipeHistoryExcel,
  getScannedPipesHistory,
} from "./services";
import CustomDatePicker from "../../components/Chart/ProductOverProduct/DateRangePicker";
import dayjs from "dayjs";
import PipeDatePicker from "../../components/PipeDatePicker/PipeDatePicker";
import {
  notifyError,
  notifySuccess,
} from "../../components/ToastNotification/ToastNotification";

const PipesDetails = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [pipesData, setPipesData] = useState([]);

  const [showTime, setShowTime] = useState(false);

  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);

  const startDate = startDateReFormat
    ? dayjs(startDateReFormat).format("YYYY-MM-DD")
    : "";
  const endDate = endDateReFormat
    ? dayjs(endDateReFormat).format("YYYY-MM-DD")
    : "";
  const startTime = startDateReFormat
    ? dayjs(startDateReFormat).format("HH:mm:ss")
    : "";
  const endTime = endDateReFormat
    ? dayjs(endDateReFormat).format("HH:mm:ss")
    : "";

  const [filters, setFilters] = useState({
    status: "",
    dateTime: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    uid: "",
    product: "",
    size: "",
    scanBy: "",
    location: "",
    device: "",
    attachment: "",
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    handleGetPipesData();
  }, [page, rowsPerPage, filters, startDate, endDate, showTime, startTime, endTime]);

  const handleGetPipesData = async () => {
    const params = {};

    if (startDate && endDate) {
      if (showTime) {
        params.start_datetime = `${startDate} ${startTime}`;
        params.end_datetime = `${endDate} ${endTime}`;
      } else {
        params.start_datetime = `${startDate} 00:00:00`;
        params.end_datetime = `${endDate} 23:59:59`;
      }
    }

    try {
      const resp = await getScannedPipesHistory(page, rowsPerPage, filters, params);
      if (resp.status === 200 || resp.status === 201) {
        setPipesData(resp.data.results);
        setCount(resp.data.count);
      }
    } catch (error) {
      setPipesData([]);
    }
  };


  const columns = [
    { id: "status", label: "Status" },
    { id: "dateTime", label: "Date & Time" },
    { id: "firstName", label: "First Name" },
    { id: "lastName", label: "Last Name" },
    { id: "mobileNumber", label: "Mobile Number" },
    { id: "uid", label: "UID" },
    { id: "product", label: "Product" },
    { id: "size", label: "Size" },
    { id: "scanBy", label: "Scan by" },
    { id: "location", label: "Location" },
    { id: "device", label: "Device" },
    { id: "attachment", label: "Attachment" },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "counterfeit":
        return "#FE3838";
      case "cross selling":
        return "#FFA500";
      case "genuine":
        return "#19BB4D";
    }
  };

  const statusOptions = [
    { value: "", label: "All" },
    { value: "3", label: "Counterfeit" },
    { value: "2", label: "Cross Selling" },
    { value: "1", label: "Genuine" },
  ];

  const deviceOptions = [
    { value: "", label: "All" },
    { value: "1", label: "IOS" },
    { value: "0", label: "Android" },
  ];

  // Add new state for search filters

  // Add filter handler
  const handleFilterChange = (columnId, value) => {
    setFilters((prev) => ({
      ...prev,
      [columnId]: value,
    }));
  };

  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const handleStartDate = (newStartDate) => {
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
    }
  };

  const handleExcel = async () => {
    const params = {};

    if (showTime) {
      params.start_date = `${startDate} ${startTime}`;
      params.end_date = `${endDate} ${endTime}`;
    } else {
      params.start_date = `${startDate} 00:00:00`;
      params.end_date = `${endDate} 23:59:59`;
    }
    try {
      const resp = await exportScannedPipeHistoryExcel(params);
      if (resp.status == 200 || resp.status == 201) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      notifyError(error.response.data.message);
    }
  };

  return (
    <Box className="pipes-details-container">
      <Box className="pipes-details-header">
        <Link to="/" className="page-back-link">
          <ArrowBackIcon />
          <span className="back-text">Pipes</span>
        </Link>

        <Box className="pipes-details-header-content d-flex gap-2">
          <div className="d-flex">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                className="time-picker"
                value="top"
                control={<Switch color="primary" checked={showTime} />}
                label="Time"
                labelPlacement="top"
                onChange={handleToggleTime}
              />
            </FormGroup>

            <PipeDatePicker
              time={showTime}
              startDateReFormat={startDateReFormat}
              endDateReFormat={endDateReFormat}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              Start_Date_lable={"Start Date"}
              end_Date_lable={"End Date"}
            />
          </div>
          <button
            className="page-header-btn"
            onClick={handleExcel}
            disabled={!startDateReFormat || !endDateReFormat}
          >
            <img src={images.excelIcon} alt="" />
          </button>
        </Box>
      </Box>

      <Box className="pipes-details-table-container">
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} className="pipes-details-table-cell">
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} className="search-table-row">
                  {column.id === "status" ? (
                    <select
                      className="status-dropdown"
                      value={filters.status}
                      onChange={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                    >
                      {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : column.id === "device" ? (
                    <select
                      className="status-dropdown"
                      value={filters.device}
                      onChange={(e) =>
                        handleFilterChange("device", e.target.value)
                      }
                    >
                      {deviceOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <>
                      <SearchIcon className="table-search-icon" />
                      <input
                        type="search"
                        placeholder={column.label}
                        name={column.id}
                        value={filters[column.id]}
                        onChange={(e) =>
                          handleFilterChange(column.id, e.target.value)
                        }
                      />
                    </>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {pipesData.map((row) => (
              <TableRow key={row.id}>
                <TableCell className="pipes-details-table-cell">
                  <Box
                    className="status-box"
                    style={{ backgroundColor: getStatusColor(row.status) }}
                  ></Box>
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.date_time}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.first_name}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.last_name}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.mobile_number}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.uid}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.product}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.size}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.scan_by}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.location}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.device_type}
                </TableCell>
                <TableCell className="pipes-details-table-cell">
                  {row.attachment && (
                    <a
                      href={row.attachment}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="attachment-link"
                    >
                      Download File
                    </a>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box className="pipes-details-pagination">
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>

      {/* Add the legend here */}
      <Box className="d-flex justify-content-between footer-text">
        <Box className="d-flex align-items-center gap-4 mb-3 ms-3">
          <div className="d-flex align-items-center gap-2">
            <Box className="status-box" style={{ backgroundColor: "#FE3838" }}></Box>
            <span>Counterfeit</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Box className="status-box" style={{ backgroundColor: "#FFA500" }}></Box>
            <span>Cross Selling</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Box className="status-box" style={{ backgroundColor: "#19BB4D" }}></Box>
            <span>Genuine</span>
          </div>
        </Box>
        <p style={{ margin: 0, marginBottom: 0 }}>
          Powered by <b>Hikar&#174;Technomation</b> Private Limited &#169; All
          Rights Reserved
        </p>
      </Box>
    </Box>
  );
};

export default PipesDetails;
